// @ts-check

import { modes, shapeTypes } from 'constants/index';

/**
 * @param {object} scene
 * @param {import('actions/scene.types').ScenePage[]} [scene.pages]
 * @returns {import('actions/scene.types').Shape[]}
 */
const getSceneShapes = ({ pages }) => {
  if (Array.isArray(pages) && pages.length) {
    return pages.flatMap((page) => page?.shapes || []);
  }
  return [];
};

/**
 * Checks whether all editable image zones are filled with photos.
 * In `photoPrint` mode empty zones are allowed, so it always returns `true`.
 *
 * @param {import('actions/scene.types').SceneState} [scene] Scene object from redux state.
 * @returns {boolean}
 */
export const isAllImageLoaded = (scene) => {
  const { config: { mode } = {}, pages = [] } = scene || {};
  const shapes = getSceneShapes({ pages });
  const emptyImageZones = shapes.filter(
    (shape) => (shape?.type === shapeTypes.dropZone || shape?.type === shapeTypes.layout) && !shape?.image,
  );
  return mode === modes.photoPrint || !emptyImageZones.length;
};
